import {connect} from 'react-redux';
import BasicLayout from '../../components/BasicLayout';
import {articlesSelector} from '../../selectors/articles';

function mapStateToProps(state) {
  return {
    articles: articlesSelector(state),
    loading: state.search.sending || state.articles.loading,
    experiments: state.experiments.active
  };
}

const ConnectedBasicLayout = connect(mapStateToProps)(BasicLayout);
export default ConnectedBasicLayout;
